<script setup>
   //this section MUST NOT be used, anything that would need to be put here needs to be added to a global middleware. This component MUST only be used for layout
   // Exception: read-only build-time stamp for deploy verification (no logic/side effects).
   const { buildTime } = useRuntimeConfig().public;
</script>

<template>
   <div>
      <!-- Deploy verification marker. Query in the browser console:
           document.querySelector('[data-build-time]').dataset.buildTime -->
      <span hidden :data-build-time="buildTime" />
      <NuxtLayout>
         <NuxtPage />
      </NuxtLayout>
   </div>
</template>
